import React, { Component } from "react";
import { withRouter, NavLink } from "react-router-dom";
import {
  BoxDanger,
  MnemoCallout,
  MnemoLoading,
  MSection,
  SupportoTecnicoLive,
  Title,
} from "components/misc";
import {
  dateHelper,
  learningService,
  lessonLiveService,
  networkErrorHelper,
} from "libs";
import { LESSON_TYPE, ROUTES } from "const";
import { Icon, Button } from "design-react-kit";

class CourseLessonScheduleAll extends Component {
  state = {
    loading: true,
    loadingError: false,
    rCode: "",
    course: {},
    userCourse: {},
    lessons: [],
  };

  componentDidMount() {
    const { rCode } = this.props.match.params;
    this.setState({ rCode: rCode });
    this.loadUserCourse(rCode);
  }

  loadUserCourse(rCode) {
    learningService
      .courseDashboard(rCode)
      .then(({ data }) => {
        const { course, userCourse } = data.payload;
        this.setState({ course, userCourse });

        this.loadRemote(course.id, userCourse.registrationCode);
      })
      .catch((error) => {
        if (!networkErrorHelper.is404(error)) {
          console.log(error);
          networkErrorHelper.notify(error);
        }
      });
  }

  loadRemote(courseId, rCode) {
    lessonLiveService
      .MyScheduleAll(courseId, rCode)
      .then(({ data }) => {
        this.setState({
          loading: false,
          lessons: data.payload.lessons,
        });
      })
      .catch((error) => {
        console.log(error);
        if (!networkErrorHelper.is404(error)) {
          console.log(error);
          networkErrorHelper.notify(error);
        }

        this.setState({
          loading: false,
          ladingError: true,
        });
      });
  }

  goDetail = (idLesson) => {
    const { rCode } = this.state;

    const lesson = this.state.lessons.find((lesson) => lesson.id === idLesson);
    if (!lesson) {
      console.error(`Lesson with ID ${idLesson} not found.`);
      return;
    }

    console.log(lesson);
    if (lesson.type === LESSON_TYPE.LESSON_ONSITE) {
      window.location = `${ROUTES.COURSE_LESSONONSITE_DETAIL}/${rCode}/${idLesson}`;
    } else {
      window.location = `${ROUTES.COURSE_LESSONLIVE_DETAIL}/${rCode}/${idLesson}`;
    }
  };

  getLocation = (onsite) => {
    let location = "";

    // verify if the location exists by region
    if (onsite.location) {

      const tLocation = JSON.parse(onsite.location);

      //  get the value of first key of the object, because the location is not always in the region key
      const firstKey = Object.keys(tLocation)[0];
      location = tLocation[firstKey] || "";

      // Replace all hyphens with double <br /> for HTML line breaks
      const lines = String(location)
        .split(/\r\n|\n\r|\r|\n/)
        .map(s => s.trim())
        .filter(Boolean);
      location = lines.map(s => `&bull; ${s}`).join("<br />");
    }
    return location;
  };

  showLinkIdMeet(lesson) {

    let show = false;

    if (lesson.idMeet) {

      const dayLeft = dateHelper.dayLeft(dateHelper.toUSDate(lesson.date));
      if (dayLeft === 0) {
        const minuteLeft = dateHelper.minuteLeft(lesson.hourStart);

        // il link si attiva da 60 minuti prima a 4 ore dopo l'inizio della lezione
        if (minuteLeft < 60 && minuteLeft > -240) {
          show = true;
        }
      }
    }

    return show;
  }

  showLinkUrlRegister(lesson) {

    let show = false;

    if (lesson.urlRegister) {

      const dayLeft = dateHelper.dayLeft(dateHelper.toUSDate(lesson.date));
      if (dayLeft === 0) {
        const minuteLeft = dateHelper.minuteLeft(lesson.hourStart);

        // il link si attiva da 2 ore prima a 4 ore dopo l'inizio della lezione
        if (minuteLeft < 180 && minuteLeft > -240) {
          show = true;
        }
      }
    }

    return show;
  }

  openLink = (link) => {
    window.open(link, '_blank');
  };

  renderLessons(lessons) {

    return (
      <MSection className="m-2">
        {lessons.length > 0 && (
          <>
            <table className="table table-striped">
              <thead>
                <tr>
                  <th scope="col">Data</th>
                  <th scope="col">Insegnamento</th>
                  <th scope="col">Docente</th>
                  <th scope="col">Ora inizio</th>
                  <th scope="col">Modalità erogazione</th>
                  <th scope="col"></th>
                </tr>
              </thead>
              <tbody>
                {lessons.map((lesson, i) => {

                  return (
                    <tr key={i}>
                      <td>{dateHelper.toITDate(lesson.date)}</td>
                      <td>{lesson.subject}<br/><b>{lesson.note}</b></td>
                      <td>{lesson.teacher}</td>
                      <td>{dateHelper.toShortTime(lesson.hourStart)}</td>
                      <td>
                        {(lesson.type === LESSON_TYPE.LESSON_ONSITE) ? (
                          <>
                            PRESENZA<br />
                            <span
                              dangerouslySetInnerHTML={{
                                __html: this.getLocation(lesson),
                              }}
                            />
                          </>
                        ) : (
                          <>ONLINE</>
                        )}
                      </td>

                      <td>
                        {(lesson.type === LESSON_TYPE.LESSON_LIVE) && (
                          <>
                            {this.showLinkUrlRegister(lesson) && (
                              <Button
                                color="primary m-1"
                                outline
                                onClick={(e) => {
                                  this.openLink(lesson.urlRegister);
                                }}>
                                Registrati
                              </Button>
                            )}
                            {this.showLinkIdMeet(lesson) && (
                              <>
                                <Button
                                  color="primary m-1 btn-block"
                                  outline
                                  onClick={(e) => {
                                    this.openLink(lesson.idMeet);
                                  }}>
                                  Partecipa
                                  {(parseInt(lesson.myRegistrationIDWebex) > 0) && <div><small class="text-muted">codice registrazione: {lesson.myRegistrationIDWebex}</small></div>}
                                </Button>

                              </>
                            )}
                          </>)}
                        {
                          <Button
                            id="radio"
                            color="primary bg-dark m-1 btn-block"
                            onClick={(e) => {
                              this.goDetail(lesson.id);
                            }}
                          >
                            Dettaglio
                          </Button>
                        }
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </>
        )
        }
      </MSection>
    );
  }

  render() {
    const {
      loading,
      loadingError,
      lessons,
      rCode,
      userCourse,
    } = this.state;

    if (loading) return <MnemoLoading></MnemoLoading>;
    if (loadingError)
      return (
        <BoxDanger className="m-5">
          Si è verificato un errore durante l'elaborazione della richiesta. <SupportoTecnicoLive courseCode={userCourse.courseCode} />
        </BoxDanger>
      );

    return (
      <>
        <NavLink
          to={`${ROUTES.COURSE_DASHBOARD}/${rCode}`}
          className="mx-5 btn btn-outline-primary float-right"
        >
          <Icon icon="it-presentation" /> TORNA ALLA HOME PAGE DEL CORSO
        </NavLink>
        <Title>Lezioni in presenza</Title>
        {this.renderLessons(lessons)}
        <div className="m-2">
          <MnemoCallout>
            <p>Calendario in continuo aggiornamento.</p>
          </MnemoCallout>          
        </div>
         <SupportoTecnicoLive courseCode={userCourse.courseCode} />
      </>
    );
  }
}

export default withRouter(CourseLessonScheduleAll);
